<template lang="pug">
    el-dialog(:title="handtitle",class="el-dialog-custom",top="3vh",width="95%",:visible.sync='visible' :modal-append-to-body='false' :append-to-body='true' @close="closeForm()")
      el-form(:model="ruleForm", :inline="false" :rules="rules", ref="addFrom", label-width="100px")
          el-card(shadow="never")
            div(slot="header")
               font(style="font-weight: bold;font-size:18px;") 培训设置
            div
              el-form-item(label="培训ID:" prop="id" v-show="false")
                  el-input.width_ct(v-model="ruleForm.trainCode" disabled)
                  font.font_later 新建后自动生成！
              el-form-item(label="培训名称:" prop="name")
                  el-input.width_ct(v-model="ruleForm.name" @input="descInput"  placeholder="请填写培训名称" type="text" maxlength="40" show-word-limit)
                  font.font_later 您还可以输入
                  font.font_style {{nameFont}}
                  font.font_color 个字!
              el-form-item(label="主办方:" prop="orgId")
                  el-select.sel_width_ct(v-model="ruleForm.orgId" placeholder="请选择主办方" filterable clearable @change="changeCity")
                      el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )
              el-form-item(label="主办城市:" prop="provinceCode")
                  el-col(style="width:20%;")
                      el-input(v-model="ruleForm.provinceName" v-show="false")
                      el-select(v-model="ruleForm.provinceCode" placeholder="请选择省" style="width:100%;" :disabled="cityDisbaled" @change="changeProvice")
                          el-option(v-for="(item,index) in provinceList",:key="index",:label="item.name",:value="item.code" )
                  el-col(style="width:2%;" class="line") &nbsp;&nbsp;省&nbsp;&nbsp;
                  el-col(style="width:20%;")
                      el-input(v-model="ruleForm.cityName" v-show="false")
                      el-select(v-model="ruleForm.cityCode" placeholder="请选择市" style="width:100%;" :disabled="provinceDisabled" @change="selectCity")
                          el-option(v-for="(item,index) in cityList",:key="index",:label="item.cityname",:value="item.citycode" )
                  el-col(style="width:20%;") &nbsp;&nbsp;市&nbsp;
              el-form-item(label="联系电话:" prop="byx3" v-if="ruleForm.type == 5")
                  el-input(v-model="ruleForm.byx3" style='width:20%')
              el-form-item(label="是否推荐首页:" prop="recommend")
                    el-radio(v-model="ruleForm.recommend" :label='1') 是
                    el-radio(v-model="ruleForm.recommend" :label='0') 否
              div(v-if="ruleForm.type != 5")
                el-form-item(label="培训场地:" prop="placesId")
                    el-select.sel_width_ct(v-model="ruleForm.placesId" placeholder="请选择培训场地" clearable :disabled="venueIdDisabled" @change="venueIdChange")
                        el-option(v-for="(item,index) in venueList" :key="index" :label="item.name" :value="item.id")
                    font.font_later(v-if="ruleForm.venueAddress") 地址: {{ruleForm.venueAddress}}
                el-form-item(label="班级人数:" prop="classCount")
                        el-input.sel_width_ct(v-model='ruleForm.classCount' clearable placeholder="请填写班级人数" )
                el-form-item(label="报名时间:" prop="applyStrTime" )
                    el-date-picker.sel_width_ct(v-model="ruleForm.applyStrTime" @blur="applyDateChange"  type="datetime" placeholder="请选择报名时间" format="yyyy-MM-dd HH:mm" value-format="timestamp" clearable)
                el-form-item(label="报名截止:" prop="applyEndTime")
                    el-date-picker.sel_width_ct(v-model="ruleForm.applyEndTime" type="datetime" :disabled="ctDisabled" :placeholder="matchStartTimePlaceholder" format="yyyy-MM-dd HH:mm" @change="changeMatchStartTime"  :picker-options="pickerOptionsCt" value-format="timestamp" clearable)
                el-card(shadow="never")
                  div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 课程设置
                  div
                    el-row
                      el-col(:span='6')
                          el-form-item(label="培训日期:")
                              el-date-picker(v-model="classSeting.trainTime" placeholder="请先填选报名截止时间" :disabled="!ruleForm.applyEndTime" type="date"  format="yyyy-MM-dd" value-format="yyyy-MM-dd" @blur="pxTimeSd" :picker-options="pickerOptionsPxrq"  clearable)
                      el-col(:span='6')
                          el-form-item(label="时段")
                              el-time-select(v-model='classSeting.strTime' :disabled="!classSeting.trainTime" style='width:115px', @change="strTimeChange" default-value="09:20" :picker-options="{start: '00:00',step: '00:05',end: '24:00',minTime:pxmintime}")
                              font &nbsp;—&nbsp;
                              el-time-select(v-model='classSeting.endTime' :disabled="!classSeting.strTime" style='width:115px', :picker-options="{start: classSeting.strTime,step: '00:05',end: '24:00',minTime:classSeting.strTime}")
                      el-col(:span='6')
                          el-form-item(label="场地编号:")
                              el-input(style='width:220px;' v-model="classSeting.placeCode" @blur="placeCodeBlur")
                      el-col(:span='6')
                          div(style="float:right")
                              el-button(type="primary" @click="addClaseSeting" :disabled="(ruleForm.type == 1)&&(ruleForm.trainCourseList.length>=1)") 添加
                              el-button(type="danger" @click="delClassSeting" :disabled="checkedClass.length<1") 删除
                    el-table(:data="ruleForm.trainCourseList" @selection-change="classCheck" border)
                      el-table-column(type='selection', header-align='center', align='center', width='50')
                      el-table-column(type="index" label="课程编号" align='center' width='150')
                      el-table-column(prop="trainTime" label="培训日期" align='center')
                      el-table-column(prop="strTime" label="开始时间" align='center')
                      el-table-column(prop="endTime" label="结束时间" align='center')
                      el-table-column(prop="placeCode" label="场地编号" align='center')
                br
                el-form-item(label="级别" prop="level")
                    el-select.sel_width_ct(v-model='ruleForm.level'  clearable  placeholder="请选择级别")
                        el-option(v-for="item in pxLevel" :label="item.label" :value="item.value")
                el-form-item(label="是否替补:" prop="bench")
                    el-radio(v-model="ruleForm.bench" :label='1') 是
                    el-radio(v-model="ruleForm.bench" :label='0') 否              
              el-form-item(label="列表页图:" prop="imgList")
                  el-input(v-model="ruleForm.tablePic" v-show="false")
                    //- el-upload(:http-request="uploadFileList",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
                    //-     img(v-if="listImageUrl" :src="listImageUrl" class="avatar" style="width:245px;height:178px;" )
                    //-     i(v-else class="el-icon-plus avatar-uploader-icon" style="width:245px;height:178px;" )
                  img(v-if="listImageUrl" :src="listImageUrl" class="avatar" @click="openImgdailog(1)" style='width:256px;height:190px')
                  i(v-else class="el-icon-plus avatar-uploader-icon" style="width:240px;height:174px;" @click="openImgdailog(1)")
                  imgupload(v-if="openImg_l" ref="upimg_l" :width="256" :height="190" @uploadSuccess='doneup_l')
                  el-alert(title="建议最小分辨率256×190,上传图片格式仅支持jpg,jpeg,png,大小不超过10M" effect='light' :closable="false")
              el-form-item(label="详情页图:" prop="imgDetailList")
                  el-input(v-model="ruleForm.detailPic" v-show="false")
                    //- el-upload(:http-request="uploadFileDetail",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
                    //-     img(v-if="detailImageUrl" :src="detailImageUrl" class="avatar" style="width:317px;height:178px;" )
                    //-     i(v-else class="el-icon-plus avatar-uploader-icon" style="width:317px;height:178px;" )
                  img(v-if="detailImageUrl" :src="detailImageUrl" class="avatar" @click="openImgdailog(2)" style='width:750px;height:310px')
                  i(v-else class="el-icon-plus avatar-uploader-icon" style="width:317px;height:178px;" @click="openImgdailog(2)")
                  imgupload(v-if="openImg_d" ref="upimg_d" :width="750" :height="310" @uploadSuccess='doneup_d')
                  el-alert(title="建议最小分辨率750×310,上传图片格式仅支持jpg,jpeg,png,大小不超过10M" effect='light' :closable="false")
              el-form-item(label="培训简介:" prop="trainAbstract")
                  d2-quill(v-show="showQuill" ref="d2-quill" v-model="ruleForm.trainAbstract"  style="min-height: 200px;")
              el-form-item(label="培训须知:" prop="trainNotice" v-if="ruleForm.type != 5")
                  el-input(v-model="ruleForm.trainNotice" type="textarea" style='display:none;')
                  d2-quill(v-show="showQuill" ref="trainNotice" v-model="ruleForm.trainNotice"  style="min-height: 200px;")
          br
          div(v-if="ruleForm.type != 5")
            el-card(shadow="never")
              div(slot="header")
                font(style="font-weight: bold;font-size:18px;") 报名设置
              div
                div(style='display:flex;align-items: center;')
                  el-form-item(label="年龄限定:" prop="ageStr")
                      el-input(v-model="ruleForm.ageStr" style='width:120px')
                  div(style='margin:0px -20px 30px 10px;') 至
                  el-form-item.ageStyle(label="" prop="ageEnd" style="width:36px")
                      el-input(v-model="ruleForm.ageEnd" style='width:120px;')
                div(style='display:flex;align-items: center;')
                  el-form-item(label="级别限定:" prop="levelStr")
                      el-select(v-model='ruleForm.levelStr' style='width:120px')
                        el-option(v-for="(e,i) in pxLevel" :label="e.label" :value='e.value' :key="i")
                  div(style='margin:0px -20px 30px 10px;') 至
                  el-form-item.ageStyle(label="" prop="levelEnd" style="width:36px")
                      el-select(v-model='ruleForm.levelEnd' style='width:120px')
                        el-option(v-for="(e,i) in pxLevel" :label="e.label" :value='e.value' :key="i")
                  el-form-item(label="" style="margin-left:108px")
                    el-button(@click="levelAll" plain) 不限级别
                el-form-item(label="角色限定:" prop="roleLimit")
                    el-checkbox-group(v-model="roleLimits" @change="genderLimitChange")
                        el-checkbox(:label='1' ) 在职人员
                        el-checkbox(:label='2') 在校人员
                        el-checkbox(:label='3') 退休人员
                        el-checkbox(:label='4') 志愿者
                        el-checkbox(:label='5') 家长
                        el-checkbox(:label='6') 其他
            br
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 教练设置
                div
                    el-row
                      el-col(:span='8')
                         el-form-item(label-width="auto")
                              el-checkbox(v-model="ruleForm.isShowCoach") 显示教练
                      el-col(:span='10')
                         el-form-item(label-width="auto")
                            //-   el-checkbox(v-model="ruleForm.coachEvaluationRequired") 教练员需评价
                              el-select(v-if="ruleForm.coachEvaluationRequired" v-model="ruleForm.coachEvaluationCount" placeholder="评价次数" style="width:130px;margin-left:16px")
                                  el-option(v-for="count in 5" :key="count" :label="count + '次'" :value="count")
                      el-col(:span='6')
                          div(style="float:right")
                              el-button(type="primary" @click="addEnrollView") 添加
                              el-button(type="danger" @click="delCoachs" :disabled="trainCoachLists.length<1") 删除
                      el-table(:data="ruleForm.trainCoachList" @selection-change="checkCoach" border)
                          el-table-column(type='selection', header-align='center', align='center', width='50')
                          el-table-column(prop="name" label="姓名" align='center')
                          el-table-column(prop="sex" label="性别" align='center')
                              template(slot-scope="scope")
                                  font(v-if="scope.row.sex === 0") 男
                                  font(v-if="scope.row.sex === 1") 女
                          el-table-column(prop="coachLevel" label="级别" align='center')
                          el-table-column(prop="phone" label="联系电话" align='center')
            br
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 报名费用
                div
                    el-row(style="padding-bottom:15px;" :span="24")
                        el-col(:md='23' :sm="5")
                            el-button(@click='addFeeTemplate(1)'  type='primary') 选择模板
                    el-table(:data="ruleForm.trainCostList" border)
                        el-table-column(prop="role" label="角色" align='center')
                        el-table-column(prop="cost" label="报名费用" align='center')
                          template(slot-scope="scope")
                                font ￥&nbsp;&nbsp;
                                el-input-number(v-model ="scope.row.cost" :precision="2" :min="0" :max="1000000")
                                font &nbsp;&nbsp;&nbsp;&nbsp;元
            br
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 退款设置
                div
                    el-row(style="padding-bottom:15px;" :span="24")
                        el-col(:md='23' :sm="5")
                            el-button(@click='addFeeTemplate(2)'  type='primary') 选择模板
                    el-row
                      el-col(:span="8")
                            el-form-item(label="报名时间距培训开始≤" label-width="auto")
                                el-input-number(v-model="tMoneyStr" :min="0" :max="100000000" :step="1")
                                font &nbsp;&nbsp;&nbsp;小时
                      el-col(:span="8")
                            el-form-item(label="退款比例:")
                                el-input-number(v-model="tmoneyBL" :min="0" :max="100")
                                font &nbsp;&nbsp;&nbsp;%
                      el-col(:span="8" )
                            div(style="float:right")
                                el-button(@click="addCtRefund" type="primary") 添 加
                                el-button(@click="delCtRefund" type="danger" :disabled="delCtRefundDisabled") 删 除
                    el-table(:data="ruleForm.trainRefundList" border @selection-change='selectionChangeHandle')
                      el-table-column(type='selection', align='center', width='50')
                      el-table-column(type="index" label="序号"  align='center', width='100')
                      el-table-column(prop="refundFee" label="距比赛开始时间/小时（含）" align='center')
                      el-table-column(prop="refundScale" label="退款比例/%" align='center')
          //- 选择模板
          add-fee-template(v-if='addFeeTemplateVisible', ref="addFeeTemplate", @chooseTemplate='chooseTemplate')
          el-dialog(title="添加教练"  :visible.sync="addVisible" width="80%" :append-to-body='true' :modal-append-to-body='false')
                el-row
                   el-col(:span="11")
                      el-card(shadow="never")
                        div(slot="header")
                            el-row
                                el-col(:span='22')
                                    el-input(v-model='memberName' clearable, style='width:80%;' placeholder="请输入姓名/级别/手机号码")
                                el-col(:span='2')
                                    el-button(@click="getLeftData" style='float:right;' icon='el-icon-search') 查询
                        div
                          el-table(:data="leftData" border  @selection-change="checkAll" max-height="300")
                              el-table-column(type="selection" align='center')
                              el-table-column(prop="name" label="姓名" align='center')
                              el-table-column(prop="sex" label="性别" align='center'  )
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.sex === 0") 男
                                    font(v-if="scope.row.sex === 1") 女
                              el-table-column(prop="coachLevel" label="级别" align='center'  )
                              el-table-column(prop="phone" label="手机号码" align='center' )
                          el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
                   el-col(:span="2")
                      div.opSetting
                          div(@click="handelSelect" )
                              el-button(style='padding:10px'    icon="el-icon-d-arrow-right" :disabled="nowSelectData.length ? false:true" :size="buttonSize" type="primary") 选中
                          div.spacing(@click="handleRemoveSelect")
                              el-button(style='padding:10px' icon="el-icon-d-arrow-left" :disabled="nowSelectRightData.length ? false:true" :size="buttonSize" type="danger") 取消
                   el-col(:span="11")
                        el-card(shadow="never")
                            div(slot="header")
                                font.font_label 已选择的教练
                            div
                                el-table(:data="rightData" border @selection-change="checkRightAll" max-height="300")
                                    el-table-column(type="selection" align='center')
                                    el-table-column(prop="name" label="姓名" align='center')
                                    el-table-column(prop="sex" label="性别" align='center' )
                                        template(slot-scope="scope")
                                            font(v-if="scope.row.sex === 0") 男
                                            font(v-if="scope.row.sex === 1") 女
                                    el-table-column(prop="coachLevel" label="级别" align='center' )
                                    el-table-column(prop="phone" label="手机号码" align='center' )
                span.dialog-footer(slot="footer")
                    el-button(@click="addEnroll" type="primary") 确 定
                    el-button(@click="addVisible=false") 取 消

      span.dialog-footer(slot="footer")
          el-button(@click="ruleFormSubmit()" type="primary" v-if='flagType == 3') 复制新建
          el-button(type="primary" @click="ruleFormSubmit()" v-else) 确 定
          el-button(@click="closeForm()") 取 消
</template>
<script>
import commonData from '../common.js'
export default {
	data () {
		var trainNotice_rule = (rule, value, callback) => {
			if (!value || value === '<p><br></p>') {
				callback(new Error('培训须知不能为空!'))
			} else {
				callback()
			}
		};
		var ageLimitStr = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('必须限定年龄！'))
			} else if (!/^[+]{0,1}(\d+)$/.test(value) || value <= 0) {
				return callback(new Error('请输入正整数！'))
			} else if (this.ruleForm.ageEnd) {
				setTimeout(() => {
					if (
						this.ruleForm.ageStr * 1 >=
							this.ruleForm.ageEnd * 1 ||
						this.ruleForm.ageEnd >= 100
					) {
						callback(new Error('年龄范围错误'))
					} else {
						callback()
					}
				}, 100)
			}
		}
		var ageLimitEnd = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('必须限定年龄！'))
			} else if (!/^[+]{0,1}(\d+)$/.test(value) || value <= 0) {
				return callback(new Error('请输入正整数！'))
			} else if (this.ruleForm.ageStr) {
				setTimeout(() => {
					if (
						this.ruleForm.ageStr * 1 >=
							this.ruleForm.ageEnd * 1 ||
						this.ruleForm.ageEnd >= 100
					) {
						callback(
							new Error(
								'年龄范围错误,且最大值不超过100，请重新填写！'
							)
						)
					} else {
						callback()
					}
				}, 100)
			}
		}
		var leaveLimitStr = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('必须限制会员级别！'))
			} else if (this.ruleForm.levelEnd) {
				setTimeout(() => {
					if (
						this.ruleForm.levelStr * 1 >=
						this.ruleForm.levelEnd * 1
					) {
						callback(new Error('级别范围错误！'))
					} else {
						callback()
					}
				}, 100)
			}
		}
		var leaveLimitEnd = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('必须限制会员级别！'))
			} else {
				setTimeout(() => {
					if (
						this.ruleForm.levelStr * 1 >=
						this.ruleForm.levelEnd * 1
					) {
						callback(
							new Error(
								'最小级别应小于最大级别，请重新选择！'
							)
						)
					} else {
						callback()
					}
				}, 100)
			}
		}
		return {
			pxLevel: commonData.pxLevel,
			handtitle: '新增培训',
			flagType: '', //1：新增  2:修改 3：复制新建
			addFeeTemplateVisible: false,
			pxmintime: '00:00',
			ruleForm: {
				byx3: '', //联系电话
				trainCode: '',
				type: 1, //新增培训类型(1:单次 2：整期 3：青少年 4：个人定制化 5：团体定制化
				id: null,
				name: '',
				recommend: 0, //（是否推荐首页（0否，1是））
				orgId: '',
				provinceCode: '',
				provinceName: '',
				cityCode: '',
				cityName: '',
				placesId: '',
				classCount: '',
				level: '',
				bench: 1,
				applyStrTime: '',
				applyEndTime: '',
				tablePic: '',
				detailPic: '',
				trainAbstract: '',
				trainNotice: '',
				// 报名设置
				ageStr: '',
				ageEnd: '',
				levelStr: '',
				levelEnd: '',
				roleLimit: '',
				// 课程设置
				isShowCoach: false,
				coachEvaluationRequired: false,
				coachEvaluationCount: 1,
				trainCourseList: [], //课程设置列表
				//教练设置表
				trainCoachList: [],
				//费用设置
				trainCostList: [
					{
						role: '注册会员',
						roleId: '1',
						cost: '',
						byx1: 1
					},
					{
						role: '初始会员',
						roleId: '2',
						cost: '',
						byx1: 1
					},
					{
						role: '荣誉会员',
						roleId: '3',
						cost: '',
						byx1: 1
					},
					{
						role: '在职人员',
						roleId: '1',
						cost: '',
						byx1: 2
					},
					{
						role: '在校人员',
						roleId: '2',
						cost: '',
						byx1: 2
					},
					{
						role: '退休人员',
						roleId: '3',
						cost: '',
						byx1: 2
					},
					{
						role: '志愿者',
						roleId: '4',
						cost: '',
						byx1: 2
					},
					{
						role: '家长',
						roleId: '5',
						cost: '',
						byx1: 2
					},
					{
						role: '其他',
						roleId: '6',
						cost: '',
						byx1: 2
					}
				],
				//退款设置
				trainRefundList: []
			},
			roleLimits: [], //1在职、2在校生、3退休人员、4其他、5志愿者、6家长
			// 课程设置
			strTime: '',
			endTime: '',
			classSeting: {
				code: 0,
				trainTime: '',
				strTime: '',
				endTime: '',
				placeCode: ''
			},
			checkedClass: [], //勾选的课程
			trainCoachLists: [], //勾选的教练数据列表
			tMoneyStr: null,
			tmoneyBL: null,
			checkedtrainRefundLists: [], //勾选的退款数据列表
			pageSize: 10,
			totalPage: 0,
			pageIndex: 1,
			memberName: '',
			leftData: [],
			rightData: [], // 右边列表
			nowSelectData: [], // 左边选中列表数据
			nowSelectRightData: [], // 右边选中列表数据
			openImg_l: false,
			openImg_d: false,

			ctRefund: {
				index: 0,
				minDuration: 0,
				refundScale: undefined
			},

			buttonSize: 'large',
			addVisible: false,
			clickFlag: false,
			delTableList: [],
			sysOrgList: [],
			cityList: [],
			provinceList: [],
			delCtRefundDisabled: true,
			cityDisbaled: true,
			provinceDisabled: true,
			nameFont: 40,
			venueIdDisabled: true,
			venueList: [],
			placesInfoList: [],
			ageMaxMenMin: 0,
			ageMaxWomenMin: 0,
			ageMaxMenMax: 100,
			ageMaxWomenMax: 100,

			womenDisabled: false,

			loading: null,
			ctDisabled: true,
			matchStartTimePlaceholder: '必须先选择报名时间',
			pickerOptionsCt: null,
			pickerOptionsPxrq: null,
			levelDisabled: true,
			levelOptions: [
				{ value: 1.0, label: 1.0 },
				{ value: 1.5, label: 1.5 },
				{ value: 2.0, label: 2.0 },
				{ value: 2.5, label: 2.5 },
				{ value: 3.0, label: 3.0 },
				{ value: 3.5, label: 3.5 },
				{ value: 4.0, label: 4.0 },
				{ value: 4.5, label: 4.5 },
				{ value: 5.0, label: 5.0 }
			],
			rules: {
				name: [
					{
						required: true,
						message: '培训名称不能为空!',
						trigger: 'blur'
					},
					{
						max: 40,
						message: '长度不能超过40个字符!',
						trigger: 'blur'
					}
				],
				orgId: [
					{
						required: true,
						message: '主办方不能为空!',
						trigger: 'change'
					}
				],
				placesId: [
					{
						required: true,
						message: '培训场地不能为空!',
						trigger: 'change'
					}
				],
				classCount: [
					{
						required: true,
						message: '班级人数不能为空!',
						trigger: 'blur'
					},
					{
						pattern: /^[0-9]*[1-9][0-9]*$/,
						message: '请输入正整数',
						trigger: 'blur'
					}
				],
				level: [
					{
						required: true,
						message: '培训级别不能为空!',
						trigger: 'change'
					}
				],
				applyStrTime: [
					{
						required: true,
						message: '报名时间不能为空!',
						trigger: 'change'
					}
				],
				applyEndTime: [
					{
						required: true,
						message: '报名截止时间不能为空!',
						trigger: 'change'
					}
				],
				ageStr: [
					{
						required: true,
						validator: ageLimitStr,
						trigger: 'change'
					}
				],
				ageEnd: [
					{
						required: true,
						validator: ageLimitEnd,
						trigger: 'change'
					}
				],
				levelStr: [
					{
						required: true,
						validator: leaveLimitStr,
						trigger: 'change'
					}
				],
				levelEnd: [
					{
						required: true,
						validator: leaveLimitEnd,
						trigger: 'change'
					}
				],
				trainNotice: [
					{
						required: true,
						validator: trainNotice_rule,
						trigger: 'change'
					}
				],
				byx3: [
					{
						required: true,
						message: '联系电话不能为空!',
						trigger: 'blur'
					}
				]
			},
			visible: false,
			listImageUrl: '',
			detailImageUrl: '',
      showQuill: false // 这个字段是用来解决Quill富文本编辑器在初始化后会自动聚焦从而导致页面自动滚动的bug
		}
	},
	created () {
		// this.$refs['d2-quill'].quill.blur();
		// this.ruleForm.levelOptions = commonData.pxLevle
	},
	mounted () {
		//this.restaurants = this.loadAll()
		this.initCity()
	},
	methods: {
		placeCodeBlur () {
			if (
				this.classSeting.placeCode &&
				!/^[0-9]*[1-9][0-9]*$/.test(this.classSeting.placeCode)
			) {
				this.$message.error('培训场地编码请输入正整数！')
				this.classSeting.placeCode = ''
			}
		},
		levelAll () {
			this.ruleForm.levelStr = '0.0'
			this.ruleForm.levelEnd = '5.0'
		},
		// 培训其实时间改变结束时间重置
		strTimeChange (val) {
			this.classSeting.endTime = ''
		},
		//课程时间不能重叠
		nopeatClass (list, nowTime, endTime, code) {
			let max = true
			let now = new Date(nowTime).getTime()
			let end = new Date(endTime).getTime()
			list.forEach((e) => {
				if (
					e.placeCode == code &&
					max &&
					!(new Date(
						e.trainTime + ' ' + e.endTime
						).getTime() < now ||
						new Date(
						e.trainTime + ' ' + e.strTime
						).getTime() > end					
					)
				) {
					max = false
				}
			})
			console.log(now, max, 998)

			return max
		},
		// 添加课程
		addClaseSeting () {
			// 单次培训只能添加一节课
			if (!this.classSeting.trainTime) {
				return this.$message.error('培训日期不能为空!')
			}
			if (!this.classSeting.strTime) {
				return this.$message.error('起始时段不能为空!')
			}
			if (!this.classSeting.endTime) {
				return this.$message.error('结束时段不能为空!')
			}
			if (!this.classSeting.endTime) {
				return this.$message.error('结束时段不能为空!')
			}
			// if (!this.classSeting.placeCode) { return this.$message.error('场地编号不能为空!') }

			let item = {
				trainTime: this.classSeting.trainTime,
				strTime: this.classSeting.strTime,
				endTime: this.classSeting.endTime,
				placeCode: this.classSeting.placeCode
			}
			if (
				!this.nopeatClass(
					this.ruleForm.trainCourseList,
					item.trainTime + ' ' + item.strTime,
					item.trainTime + ' ' + item.endTime,
					item.placeCode
				)
			) {
				return this.$message.error(
					'课程时间不能重叠，请重新设置！'
				)
			}
			this.ruleForm.trainCourseList.push(item)
			// this.classSeting.trainTime = ''
			// this.classSeting.strTime = ''
			// this.classSeting.endTime = ''
			// this.classSeting.placeCode = ''
			this.ruleForm.trainCourseList.forEach((e, i) => {
				e.code = i + 1
			})
		},
		classCheck (val) {
			this.checkedClass = val
		},
		//删除课程
		delClassSeting () {
			if (this.checkedClass.length < 1) {
				return this.$message.error('请勾选至少一项课程！')
			}
			let arr = []
			this.checkedClass.forEach((e) => {
				arr.push(e.code)
			})
			this.ruleForm.trainCourseList = this.ruleForm.trainCourseList.filter(
				(e) => arr.indexOf(e.code) === -1
			)
		},
		// 添加教练
		addEnroll () {
			if (this.rightData.length < 1) {
				return this.$message.error('请选择教练后添加！')
			}
			if (this.rightData.length > 1) {
				return this.$message.error('只能选择一个教练！')
			}
			this.ruleForm.trainCoachList = this.rightData
			this.addVisible = false
			// let flag = 1;
			// this.rightData.forEach(e => {
			//   e.coachId = e.id;
			//   // 验证不能重复
			//   if (this.ruleForm.trainCoachList) {
			//     this.ruleForm.trainCoachList.forEach(m => {
			//       if (m.id == e.id) {
			//         flag = 2;
			//         this.$message.error('【'+m.name+'】' + "已经添加，请勿重复添加！");
			//       }
			//     });
			//   }
			// });
			// if (flag == 1) {
			//   this.ruleForm.trainCoachList = this.rightData.concat(
			//     this.ruleForm.trainCoachList
			//   );
			//   console.log(this.ruleForm.trainCoachList,8989);

			//
			// }
		},
		//勾选教练
		checkCoach (val) {
			let arr = []
			val.forEach((e) => {
				let obj = {}
				obj.coachId = e.id
				arr.push(obj)
			})
			this.trainCoachLists = val
		},
		// 删除教练
		delCoachs () {
			let arr = []
			this.trainCoachLists.forEach((e) => {
				arr.push(e.id)
			})
			let cl = this.ruleForm.trainCoachList
			this.ruleForm.trainCoachList = cl.filter(
				(e) => arr.indexOf(e.id) === -1
			)
		},
		// 图片上传
		openImgdailog (val) {
			let picType = 'trainDetailPic'
			let upimg = 'upimg_l'
			if (val === 1) {
				this.openImg_l = true
				picType = 'trainTablePic'
				upimg = 'upimg_l'
			}
			if (val === 2) {
				this.openImg_d = true
				picType = 'trainDetailPic'
				upimg = 'upimg_d'
			}
			this.$nextTick(() => {
				console.log(picType)
				this.$refs[upimg].init(picType) //传入图片类型参数
			})
		},
		// 上传完成
		doneup_l (val, url) {
			console.log(val, 88)

			this.ruleForm.tablePic = val
			this.listImageUrl = url
		},
		doneup_d (val, url) {
			console.log(val, 99)
			this.ruleForm.detailPic = val
			this.detailImageUrl = url
		},
		// 报名费用表赋值处理
		bmFreeDo (list) {
			let arr = []
			let item = {}
			list.forEach((e) => {
				item = {
					role: e.name,
					roleId: e.typeVal,
					cost: e.value,
					byx1: e.typeRole
				}
				arr.push(item)
			})
			this.ruleForm.trainCostList = arr
		},
		//退费列表赋值处理
		tkFeeDo (list) {
			let arrT = []
			let itemT = {}
			list.forEach((e) => {
				itemT = {
					id: e.id,
					refundFee: e.typeVal,
					refundScale: e.value
				}
				arrT.push(itemT)
			})
			this.ruleForm.trainRefundList = arrT
		},
		//选择模板
		addFeeTemplate (type) {
			this.addFeeTemplateVisible = true
			this.$nextTick(() => {
				this.$refs.addFeeTemplate.init(type)
			})
		},
		// 选择模板完成  type:1费用模板 2退款模板
		chooseTemplate (list, type) {
			console.log(list, type)
			if (type === 1) {
				this.bmFreeDo(list)
			}
			if (type === 2) {
				this.tkFeeDo(list)
			}
		},
		initClassSetting () {
			this.classSeting = {
				code: 0,
				trainTime: '',
				strTime: '',
				endTime: '',
				placeCode: ''
			}
		},
		init (id, flagType, type) {
			this.visible = true
			//新增培训类型 type (1:单次 2：整期 3：青少年 4：个人定制化 5：团体定制化
			this.ruleForm.type = type
			// flagType：1：新增  2:修改 3：复制新建
			this.flagType = flagType
			this.handtitle = {
				1: '新增培训',
				2: '修改培训',
				3: '复制新建培训'
			}[flagType]
			this.initClassSetting()
			this.ruleForm.id = id || null

			this.nameFont = 40

			this.listImageUrl = ''
			this.detailImageUrl = ''
			this.rightData = []
			this.ruleForm.trainCourseList = []
			this.ruleForm.trainCoachList = []
			this.ruleForm.trainRefundList = []
			this.ruleForm.trainCostList.forEach((e) => {
				e.cost = ''
			})
			this.$forceUpdate()
			this.$nextTick(() => {
				this.$refs['addFrom'].resetFields()
				if (this.$refs['d2-quill']) {
					this.$refs['d2-quill'].Quill.pasteHTML('')
				}
				this.$refs.trainNotice.Quill.pasteHTML('')
			})
			//数据初始化
      setTimeout(() => {
        this.showQuill = true
      }, 1000)
			//修改回选
			if (this.ruleForm.id) {
				this.$http({
					url: this.$http.adornUrl(
						`/pxTrain/getId/${this.ruleForm.id}`
					),
					method: 'get'
				}).then((data) => {
					if (data && data.code === 0) {
						console.log('data:', data)
						this.changeCity(data.bean.orgId)
						if (!data.bean.recommend) {
							data.bean.recommend = 0 //如果没有默认推荐字段取0
						} else {
							data.bean.recommend =
								data.bean.recommend * 1
						}
						this.ruleForm = data.bean
						this.ruleForm.isShowCoach = data.bean.isShowCoach === 1
						this.ruleForm.coachEvaluationRequired = data.bean.coachEvaluationRequired === 1
						this.ruleForm.coachEvaluationCount = data.bean.coachEvaluationCount || 1
						this.changeProvice(0)
						this.selectCity(0)
						let rolelist = data.bean.roleLimit.split(
							','
						)
						let arr = []
						for (let i = 0; i < rolelist.length; i++) {
							arr[i] = rolelist[i] * 1
						}
						this.roleLimits = arr
						if (data.bean.tablePicUrl) {
							this.listImageUrl =
								data.bean.tablePicUrl
						}
						if (data.bean.detailPicUrl) {
							this.detailImageUrl =
								data.bean.detailPicUrl
						}
						this.nameFont = 40 - data.bean.name.length
						this.ruleForm.applyStrTime = new Date(
							data.bean.applyStrTime
						).getTime()
						this.ruleForm.applyEndTime = new Date(
							data.bean.applyEndTime
						).getTime()
						if (data.bean.trainCoachList) {
							data.bean.trainCoachList.forEach(
								(e) => {
									e.id = e.coachId
								}
							)
							this.ruleForm.trainCoachList =
								data.bean.trainCoachList
						} else {
							this.ruleForm.trainCoachList = []
						}
						if (this.ruleForm.trainCourseList) {
							this.classSeting.code = this.ruleForm.trainCourseList.length
						} else {
							this.ruleForm.trainCourseList = []
						}

						if (this.$refs['d2-quill']) {
							this.$refs[
								'd2-quill'
							].Quill.pasteHTML(
								data.bean.trainAbstract
							)
						}
						this.$refs.trainNotice.Quill.pasteHTML(
							data.bean.trainNotice
						)

						this.levelDisabled = false
						this.ctDisabled = false

						this.changeMatchStartTime()
						this.applyDateChange()
						this.$forceUpdate()
					}
				})
			}
		},
		selectCity (flag) {
			if (flag !== 0) {
				this.venueList = []
				this.ruleForm.venueId = ''
			}
			this.$http({
				url: this.$http.adornUrl('/pbPlaces/getPlaceById'),
				method: 'get',
				params: this.$http.adornParams({
					orgId: this.ruleForm.orgId,
					proviceId: this.ruleForm.provinceCode,
					cityId: this.ruleForm.cityCode
				})
			}).then((data) => {
				let obj = {}
				let val = this.ruleForm.cityCode
				if (val) {
					obj = this.cityList.find((item) => {
						return item.citycode === val
					})
					if (obj) {
						this.ruleForm.cityName = obj.cityname
					}
				}
				this.venueList =
					data && data.code === 0 ? data.list : []
			})
		},
		changeProvice (flag) {
			if (flag !== 0) {
				this.cityList = []
				this.ruleForm.placesId = ''
				this.ruleForm.cityCode = ''
				this.venueList = []
				this.ruleForm.venueId = ''
			}
			this.$http({
				url: this.$http.adornUrl(
					'/dicProvinceCity/queryByOrgId'
				),
				method: 'get',
				params: this.$http.adornParams({
					orgId: this.ruleForm.orgId,
					provinceCode: this.ruleForm.provinceCode
				})
			}).then((data) => {
				let obj = {}
				let val = this.ruleForm.provinceCode
				if (val) {
					obj = this.provinceList.find((item) => {
						return item.code === val
					})
					if (obj) {
						this.ruleForm.provinceName = obj.name
					}
				}

				this.cityList = data.list
			})
		},
		descInput () {
			let len = 40 - this.ruleForm.name.length
			this.nameFont = len
		},
		openFullScreen () {
			this.loading = this.$loading({
				lock: true,
				text: 'Loading...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})
		},
		closeForm () {
      this.showQuill = false
			this.visible = false
		},
		//报名时间改变事件
		applyDateChange () {
			if (!this.ruleForm.applyStrTime) {
				this.ctDisabled = true
				this.ruleForm.applyEndTime = null
				this.matchStartTimePlaceholder = '必须先选择报名时间'
			} else {
				if (!this.ruleForm.applyEndTime) {
					this.ctDisabled = false
					this.matchStartTimePlaceholder =
						'请选择报名截止时间'
				} else {
					let date1 = new Date(
						this.ruleForm.applyStrTime
					).getTime()
					let date2 = new Date(
						this.ruleForm.applyEndTime
					).getTime()
					if (date1 >= date2) {
						this.ruleForm.applyEndTime = null
						this.matchStartTimePlaceholder =
							'报名截止时间必须大于开始时间'
					}
				}
				this.pickerOptionsCt = {
					disabledDate: (time) => {
						return (
							time <
							new Date(
								this.ruleForm.applyStrTime -
									59 * 60 * 24 * 1000
							)
						)
					}
				}
			}
		},
		changeMatchStartTime (val) {
			if (!this.ruleForm.applyEndTime) {
				this.ctDisabled = false
				this.matchStartTimePlaceholder = '请选择报名截止时间'
			} else {
				let date1 = new Date(
					this.ruleForm.applyStrTime
				).getTime()
				let date2 =
					new Date(this.ruleForm.applyEndTime).getTime() -
					60 * 1000
				if (date1 > date2) {
					this.ruleForm.applyEndTime = null
					this.matchStartTimePlaceholder =
						'报名截止时间必须大于开始时间'
				}
			}
			let time1 = new Date(this.ruleForm.applyEndTime).getTime()
			let time2 = new Date(
				this.classSeting.trainTime +
					' ' +
					this.classSeting.strTime
			).getTime()
			if (this.classSeting && time2 < time1) {
				this.initClassSetting()
			}
			this.checkedClass = []
			this.ruleForm.trainCourseList.forEach((e) => {
				let time3 = new Date(
					e.trainTime + ' ' + e.strTime
				).getTime()
				if (time3 < time1) {
					this.checkedClass.push(e)
				}
			})
			console.log('要删除的课程：', this.checkedClass)
			if (this.checkedClass.length > 0) {
				this.delClassSeting()
			}
			let ti = this.ruleForm.applyEndTime
			this.pickerOptionsPxrq = {
				disabledDate: (time) => {
					return time < new Date(ti - 59 * 60 * 24 * 1000)
				}
			}
		},
		pxTimeSd () {
			let datetime = new Date(this.ruleForm.applyEndTime)
			let mi = datetime.getMinutes()
			let ho = datetime.getHours()
			if (mi === 0) {
				mi = 59
				ho = ho - 1
			} else {
				mi = mi - 1
			}
			let m =
				(ho + '').padStart(2, '0') +
				':' +
				(mi + '').padStart(2, '0')
			let nyr =
				datetime.getFullYear() +
				'-' +
				(datetime.getMonth() + 1 + '').padStart(2, '0') +
				'-' +
				(datetime.getDate() + '').padStart(2, '0')
			if (this.classSeting.trainTime === nyr) {
				this.pxmintime = m
			} else {
				this.pxmintime = ''
			}
		},

		startAgeMenChange (value) {
			this.ageMaxMenMin = value
		},
		endAgeMenChange (value) {
			this.ageMaxMenMax = value
		},

		genderLimitChange (label) {
			this.ruleForm.roleLimit = this.roleLimits.join()
			console.log(this.ruleForm.roleLimit, 999)
		},
		// table多选事件
		selectionChangeHandle (val) {
			this.delTableList = val
			if (this.delTableList.length === 0) {
				this.delCtRefundDisabled = true
			} else {
				this.delCtRefundDisabled = false
			}
		},
		//退款设置添加事件
		addCtRefund () {
			// if (!this.tMoneyStr) { return this.$message.error('报名距培训开始时间不能为0!') }
			// if (!this.tmoneyBL) return this.$message.error('退款比例不能为空!')

			let item = {
				id: new Date().getTime(),
				refundFee: this.tMoneyStr,
				refundScale: this.tmoneyBL
			}
			this.ruleForm.trainRefundList.push(item)
			this.tMoneyStr = ''
			this.tmoneyBL = ''
		},
		//退款设置删除事件
		delCtRefund () {
			console.log(this.delTableList, 11)
			console.log(this.ruleForm.trainRefundList, 22)
			let arr = []
			this.delTableList.forEach((e) => {
				arr.push(e.id)
			})
			let arrs = this.ruleForm.trainRefundList
			this.ruleForm.trainRefundList = arrs.filter(
				(e) => arr.indexOf(e.id) === -1
			)
		},
		initCity () {
			this.$http({
				url: this.$http.adornUrl('/sysOrg/list'),
				method: 'get'
			}).then((data) => {
				this.sysOrgList =
					data && data.code === 0 ? data.list : []
			})
		},
		selClear () {
			this.placesInfoList = []
			this.ruleForm.venueAddress = ''
			this.ruleForm.venueId = ''
			this.venueList = []
			this.ruleForm.cityCode = ''
			this.ruleForm.cityName = ''
			this.cityList = []
			this.ruleForm.provinceCode = ''
			this.ruleForm.provinceName = ''
			this.provinceList = []
			this.ruleForm.placesId = ''
		},
		changeCity (val) {
			this.selClear()
			if (val === '' || val === null) {
				this.cityDisbaled = true
				this.provinceDisabled = true
				this.venueIdDisabled = true
			} else {
				this.cityDisbaled = false
				this.provinceDisabled = false
				this.venueIdDisabled = false
				this.getById(val)
			}
		},
		//获取省和市
		getById (val) {
			this.$http({
				url: this.$http.adornUrl(
					`/dicProvince/queryByOrgId/` + val
				),
				params: this.$http.adornParams({
					orgId: val
				}),
				method: 'get'
			}).then((data) => {
				if (data && data.code === 0) {
					// this.cityList.push({
					//     label : data.bean.cityName,
					//     value : data.bean.cityCode
					// })
					// this.ruleForm.cityCode = data.bean.cityCode
					// this.ruleForm.cityName = data.bean.cityName
					// this.provinceList.push({
					//     label : data.bean.proviceName,
					//     value : data.bean.code
					// })
					// this.ruleForm.provinceCode = data.bean.code
					// this.ruleForm.provinceName = data.bean.proviceName

					this.provinceList = data.list
				}
			})
		},
		//获取主办方
		getByOrgId (val) {
			this.$http({
				url: this.$http.adornUrl(`/pbPlaces/getByOrgId/` + val),
				method: 'get'
			}).then((data) => {
				if (data && data.code === 0) {
					this.placesInfoList = data.pbPlacesList
					for (let i of data.pbPlacesList) {
						this.venueList.push({
							label: i.name,
							value: i.id
						})
					}
				}
			})
		},
		venueIdChange (val) {
			let obj = {}
			if (val) {
				obj = this.venueList.find((item) => {
					return item.id === val
				})
				if (obj) {
					this.ruleForm.venueAddress = obj.address
				}
			}
		},
		checkRightAll (val) {
			this.nowSelectRightData = val
		},
		//添教练人员页面
		addEnrollView () {
			this.addVisible = true
			this.rightData = []
			this.getLeftData()
		},

		//刷新添加人员左边table
		getLeftData () {
			this.$http({
				url: this.$http.adornUrl(`/pxCoach/list`),
				method: 'post',
				data: {
					page: this.pageIndex,
					limit: this.pageSize,
					name: this.memberName
				}
			}).then((data) => {
				if (data && data.code === 0) {
					this.leftData = data.page.records
					this.totalPage = data.page.total
				} else {
					this.leftData = []
					this.totalPage = 0
				}
			})
		},
		// 每页数
		sizeChangeHandle (val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getLeftData()
		},
		// 当前页
		currentChangeHandle (val) {
			this.pageIndex = val
			this.getLeftData()
		},
		checkAll (val) {
			this.nowSelectData = val
		},
		// 选中
		handelSelect () {
			this.rightData = this.handleConcatArr(
				this.rightData,
				this.nowSelectData
			)
			this.handleRemoveTabList(this.nowSelectData, this.leftData)
			this.nowSelectData = []
		},
		// 取消
		handleRemoveSelect () {
			this.leftData = this.handleConcatArr(
				this.leftData,
				this.nowSelectRightData
			)
			this.handleRemoveTabList(
				this.nowSelectRightData,
				this.rightData
			)
			this.nowSelectRightData = []
		},
		handleConcatArr (rightData, nowSelectData) {
			let arr = []
			arr = arr.concat(rightData, nowSelectData)
			return arr
		},
		handleRemoveTabList (isNeedArr, originalArr) {
			if (isNeedArr.length && originalArr.length) {
				for (let i = 0; i < isNeedArr.length; i++) {
					for (let k = 0; k < originalArr.length; k++) {
						if (
							isNeedArr[i]['name'] ===
							originalArr[k]['name']
						) {
							originalArr.splice(k, 1)
						}
					}
				}
			}
		},
		//新增/修改方法
		ruleFormSubmit () {
			if (this.ruleForm.type != 5) {
				let free = 1
				// 新增必须有课程,教练，费用，退费
				if (this.ruleForm.trainCourseList.length < 1) {
					return this.$message.error('应至少添加一节课程！')
				}
				if (this.ruleForm.trainCoachList.length < 1) {
					return this.$message.error('应至少添加一个教练！')
				}
				if (this.ruleForm.trainRefundList.length < 1) {
					return this.$message.error(
						'应至少设置一条退费规则！'
					)
				}
				this.ruleForm.trainCostList.some((e) => {
					if (e.cost == 0) return (free = 0)
				})
				if (free == 0) {
					return this.$message.error('费用设置不能为0！')
				}
			}
			if (this.ruleForm.coachEvaluationRequired && this.ruleForm.trainCoachList.length < 1) {
				return this.$message.error('启用教练员评价时必须至少添加一个教练！')
			}
			if (this.ruleForm.coachEvaluationRequired &&
				(!this.ruleForm.coachEvaluationCount || this.ruleForm.coachEvaluationCount < 1 || this.ruleForm.coachEvaluationCount > 5)) {
				return this.$message.error('教练员需完成评价次数必须为1至5次！')
			}
			this.$refs['addFrom'].validate((valid) => {
				this.ruleForm.tablePicUrl = ''
				this.ruleForm.detailPicUrl = ''

				let arr = []
				let CoachList = this.ruleForm.trainCoachList
				if (CoachList.length > 0) {
					CoachList.forEach((e) => {
						let item = {}
						item.coachId = e.id
						arr.push(item)
					})
					this.ruleForm.trainCoachList = arr
				}
				if (this.ruleForm.type != 5 && (!this.ruleForm.trainNotice || this.ruleForm.trainNotice === '<p><br></p>')) {
					return this.$message.error('培训须知不能为空！')
				}
				//复制新建去掉id
				if (valid) {
					this.$showLoading()
					if (this.flagType === 3) {
						this.ruleForm.id = ''
						this.ruleForm.byx1 = ''
					}

					this.ruleForm.isShowCoach = this.ruleForm.isShowCoach ? 1 : 2
					this.ruleForm.coachEvaluationRequired = this.ruleForm.coachEvaluationRequired ? 1 : 0
					if (!this.ruleForm.coachEvaluationRequired) this.ruleForm.coachEvaluationCount = null
					this.$forceUpdate()

					this.$http({
						url: this.$http.adornUrl(
							`/pxTrain/${
								!this.ruleForm.id
									? 'save'
									: 'update'
							}`
						),
						method: 'post',
						data: this.ruleForm
					}).then((data) => {
						if (data && data.code === 0) {
							this.$message({
								message: '操作成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.flagType = 1
									this.visible = false
									this.$emit(
										'refreshDataList'
									)
									this.$showLoading('close')
								}
							})
						} else {
							this.$message.error(data.msg)
						}
					})
				}
			})
		}
	}
}
</script>

<style scoped>
.el-dialog-custom {
  overflow: hidden !important;
}
.el-dialog-custom /deep/ .el-dialog__body {
  height: 73vh;
  overflow: auto;
}
.el-dialog-custom /deep/ .el-dialog__footer {
  border-top: 1px solid #E9E9E9;
}
</style>

<style>
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
.width_ct {
	width: 50%;
}
.sel_width_ct,
.input_width_ct {
	width: 20% !important;
}
.font_later {
	padding-left: 20px;
	font-weight: bold;
	color: #909399;
}
.font_color {
	font-weight: bold;
	color: #909399;
}
.font_style {
	font-weight: bold;
	color: red;
}
.dialog-footer {
	padding-bottom: 150px;
}
.dialog-right {
	float: right;
} 

/* 提示框 */
.el-tooltip__popper.is-light {
	border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
	border-bottom-color: grey !important ;
}

.toolTip > p {
	margin: 0;
	padding-top: 10px;
	height: 14px;
	line-height: 14px;
	font-size: 14px;
	color: #606266;
}

/* 文本框剩余数字提示兼容ie */
.el-input .el-input__count .el-input__count-inner {
	background: none;
	line-height: initial;
	display: inline-block;
	padding: 0 5px;
}
/* 弹出遮罩层 兼容ie*/
.el-dialog__wrapper {
	width: 100% !important;
	height: 100% !important;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	overflow: auto;
	margin: 0;
}
.ageStyle {
	margin-left: -70px;
}
.ageStyle .el-form-item__error {
	width: 500px;
}
</style>
